import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertMoneyToNumber, formatAmountOnly } from '../../util/currency';
import { CurrencySymbol } from '../../components';
import { LINE_ITEM_TAP_PROCESSING_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

// Tap's card processing fee (fee + VAT) the merchant pays: a deduction inside
// the payout, shown to the merchant only, next to NOW's fee. The total below it
// is already net of this line.
const LineItemTapFeeMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const lineItem = lineItems.find(
    item => item.code === LINE_ITEM_TAP_PROCESSING_FEE && !item.reversal
  );

  if (!isProvider || !lineItem?.lineTotal) {
    return null;
  }

  const formatted = formatAmountOnly(intl, convertMoneyToNumber(lineItem.lineTotal), 2);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.tapProcessingFee" />
      </span>
      <span className={css.itemValue}>
        <CurrencySymbol size={16} />
        <span>&nbsp;{formatted}</span>
      </span>
    </div>
  );
};

LineItemTapFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTapFeeMaybe;
